<script>
    import ContentBlock from '@itslearning/prometheus/assets/templates/ContentBlock/v1/ContentBlock.svelte';
    import Link from '@itslearning/prometheus/assets/Navigation/Link/v1/Link.svelte';

    import CourseInfo from '@its-ui/enrollment-common/components/CourseInfo/CourseInfo.svelte';
    import CourseDetails from '@its-ui/enrollment-common/components/CourseDetails/CourseDetails.svelte';
    import { getCourseTitle } from '@its-ui/enrollment-common/helpers/course-title';

    import { courseEnrollmentMode } from '@its-ui/enrollment-common/constants';

    export let i18n = {};
    export let personDataPageUrl = '';
    export let enrollMode = -1;
    export let courseTitle = '';
    export let courseCode = '';
    export let courseAdministrators = [];
    export let cultureSpecificSemicolonSeparator = '';
    export let location = '';
    export let credits = '';
    export let content = '';
    export let objective = '';
    export let organisation = '';
    export let evaluation = '';
    export let numberOfFreeSeats = null;
    export let maxAllowedNumberOfSeats = null;

    let isEnrollmentEnabled = true;
    let enrollmentFeedbackText = '';
    let enrollmentFeedbackType = 'info';

    $: pageTitle = getCourseTitle(courseCode, courseTitle, i18n);

    $: {
        if (enrollMode === courseEnrollmentMode.standard) {
            enrollmentFeedbackText = i18n.course_information_Not_accessible_yet;
            enrollmentFeedbackType = 'info';
            isEnrollmentEnabled = false;
        } else if (numberOfFreeSeats !== null && numberOfFreeSeats <= 0) {
            enrollmentFeedbackText = i18n.course_information_Maximum_number_of_free_seats_is_exceeded;
            enrollmentFeedbackType = 'warning';
            isEnrollmentEnabled = false;
        } else {
            enrollmentFeedbackText = '';
            isEnrollmentEnabled = true;
        }
    }

</script>

<svelte:head>
    <title>{pageTitle}</title>
</svelte:head>

<ContentBlock title={pageTitle}
    headingLevel="h1"
    contentAreaLayout="narrow">

    <CourseInfo
        {isEnrollmentEnabled}
        {enrollmentFeedbackText}
        {enrollmentFeedbackType}>

        <div slot="actions">
            <div class="itsl-course-enrollment-external-course-info__feedback-container">
            {#if isEnrollmentEnabled}
                <Link
                    href={personDataPageUrl}
                    text={i18n.course_information_Enrol_in_the_course}
                    standalone={true}
                />
            {/if}
            </div>
        </div>

        <div slot="details">
            <CourseDetails
                {enrollMode}
                {courseTitle}
                {courseCode}
                {courseAdministrators}
                {location}
                {credits}
                {content}
                {objective}
                {organisation}
                {evaluation}
                {numberOfFreeSeats}
                {maxAllowedNumberOfSeats}
                {i18n}
            >
                <div slot="administrators">
                    {#if courseAdministrators && courseAdministrators.length > 0}
                        <ul class="itsl-course-enrollment-external-course-info__administrators">
                            {#each courseAdministrators as admin, index}
                            <li
                                class="itsl-course-enrollment-external-course-info__administrator"
                                class:itsl-course-enrollment-external-course-info__administrator--padded={index !== courseAdministrators.length - 1}>
                                {admin}{#if index !== courseAdministrators.length - 1}<span aria-hidden="true">{cultureSpecificSemicolonSeparator}</span>{/if}
                            </li>
                            {/each}
                        </ul>
                    {/if}
                </div>
            </CourseDetails>
        </div>
    </CourseInfo>
    
</ContentBlock>


